import * as React from 'react';
import { withMetroLine } from 'app/components/metro-line/with-metro-line';
import { WithMetroLineWrappedComponentProps } from 'app/components/metro-line/types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { ImportSetSectionType } from '../metroline/types';
import { ImportSetActionType, ImportSetFormProps } from '../types';
import { ImportSetContainer } from './import-set-container';
import { ImportSetDetails } from './import-set-details';
import { ImportSetLanguage } from './import-set-language';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { AlertInfo } from 'app/components/alert-info/alert-info';
import { replaceTemplateString } from 'app/infrastructure/platform';

const ImportSetFormRendererContainer: React.FC<ImportSetFormProps
  & WithMetroLineWrappedComponentProps<ImportSetSectionType>> = ({
    locale, translation, section, translationAdminAccess, options,
    actionType, formState, mainLanguage, showTranslations, switchTranslationsToggle,
    saveImportSet, duplicateImportSet, deleteImportSet, updateItem, changeLanguage,
    copyLanguageToAll, loadOptions, updateValidation,
    resetValidation, displayError, getRef, shouldRenderSection
  }) => {

    const { importSetItem, languageOptions, validation } = formState;
    const panelProps = {
      actionType,
      importSetItem,
      options,
      locale,
      validation,
      translation,
      section,
      translationAdminAccess,
      getRef,
      shouldRenderSection,
      loadOptions,
      updateItem,
      updateValidation,
      resetValidation,
      displayError
    };

    const isDuplicate = actionType === ImportSetActionType.duplicate;
    const renderLanguageOnTop = !isDefinedIncludingZero(importSetItem?.id) || isDuplicate;
    const languageSection = <ImportSetLanguage
      language={importSetItem?.language}
      mainLanguage={mainLanguage}
      languageOptions={languageOptions}
      changeLanguage={changeLanguage}
      copyLanguageToAll={copyLanguageToAll}
      showTranslations={showTranslations}
      switchTranslationsToggle={switchTranslationsToggle}
      validation={validation}
      translation={translation}
      section={section}
      getRef={getRef}
      shouldRenderSection={shouldRenderSection} />;

    return <ImportSetContainer
      actionType={actionType}
      formState={formState}
      mainLanguage={mainLanguage}
      switchTranslationsToggle={switchTranslationsToggle}
      saveImportSet={saveImportSet}
      duplicateImportSet={duplicateImportSet}
      deleteImportSet={deleteImportSet}
      updateValidation={updateValidation}
      displayError={displayError}
      validation={validation}
      translation={translation}>
      {isDuplicate
        ? <MainGridContainer>
          <div className="row mb-3">
            <AlertInfo
              text={replaceTemplateString(
                translation.duplicate_import_set_message,
                importSetItem?.description)} />
          </div>
        </MainGridContainer>
        : null}
      {renderLanguageOnTop && languageSection}
      <ImportSetDetails {...panelProps} />
      {!renderLanguageOnTop && languageSection}
    </ImportSetContainer>;
  };

export const ImportSetFormRenderer = withMetroLine<ImportSetFormProps,
  ImportSetSectionType>()(ImportSetFormRendererContainer);
